export type AffiliateProgramView = 'join' | 'member' | 'blocked';

export function deriveAffiliateProgramView({
  joined,
  blocked,
}: {
  joined?: boolean | null;
  blocked?: boolean | null;
}): AffiliateProgramView {
  if (blocked === true) return 'blocked';
  if (joined === true) return 'member';
  return 'join';
}
